import { addressCityLabel } from '~/features/activities/addressCityLabel';
import { cityCase } from './cityCase';

/**
 * The town a venue is named by on the PDP: map pins, result cards and the booking card's
 * location dropdown all use it, so one venue never reads as two places.
 *
 * The reverse-geocoded city comes first: `name` is free text and is often a bare street
 * ("Rijnkaai"), which parsing can only ever return as-is.
 */
export function venueCity(
    address: { name?: string | null; city?: string | null } | null | undefined,
    partnerCity?: string | null,
): string | null {
    return cityCase(address?.city ?? addressCityLabel(address?.name) ?? partnerCity);
}
